<template>
  <!-- 各子项目建设进度 -->
  <div class="page">
    <div :style="{filter: this.$store.state.isVague?'blur(2px)':''}">
      <div class="table-search-box">
        <el-form :inline="true" :model="formResourceBase" class="demo-form-inline">
          <el-form-item label="子项目名称：">
            <el-select size="small" v-model="formResourceBase.name" placeholder="切换子项目名称" :popper-append-to-body="false" @change="switchItems">
              <el-option v-for="(item,index) in this.regionList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>用户建设进度</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'userProgressChart'" :datas='userProgress.dataList' :transverseData='userProgress.transverseData' :colorList='userProgress.colorList' :legendList='userProgress.legendList' :innerText="'单位：人'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位用户建设情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'tsConstructionProgressChart'" :datas='tsConstructionProgress.dataList' :transverseData='tsConstructionProgress.transverseData' :colorList='tsConstructionProgress.colorList' :legendList='tsConstructionProgress.legendList' :innerText="'单位：人'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位师生活跃度占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'tsActivityChart'" :datas='tsActivity.dataList' :transverseData='tsActivity.transverseData' :colorList='tsActivity.colorList' :legendList='tsActivity.legendList' :innerText="'单位：%'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第二层 -->
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>素材资源建设进度</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'materialChart'" :datas='material.dataList' :transverseData='material.transverseData' :colorList='material.colorList' :legendList='material.legendList' :innerText="'单位：%'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <!-- <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>资源活跃数</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'constructionChart'" :datas='construction.dataList' :transverseData='construction.transverseData' :colorList='construction.colorList' :legendList='construction.legendList' :innerText="'单位：个'"></vcolumnarChart>
            </div>
          </div>
        </el-col> -->
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>资源活跃占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'activeResourcesChart'" :datas='activeResources.dataList' :transverseData='activeResources.transverseData' :colorList='activeResources.colorList' :legendList='activeResources.legendList' :innerText="'单位：%'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>素材资源建设质量</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'materialResourcesChart'" :datas='materialResources.dataList' :transverseData='materialResources.transverseData' :colorList='materialResources.colorList' :legendList='materialResources.legendList' :innerText="'单位：%'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第三层 -->
      <el-row :gutter="12" class="sameLayer" style="margin-bottom:0px;">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>原创资源占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'originalResourcesChart'" :datas='originalResources.dataList' :transverseData='originalResources.transverseData' :colorList='originalResources.colorList' :legendList='originalResources.legendList' :innerText="'单位：%'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程建设进度</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'constructionProgressChart'" :datas='constructionProgress.dataList' :transverseData='constructionProgress.transverseData' :colorList='constructionProgress.colorList' :legendList='constructionProgress.legendList' :innerText="'单位：门'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>选课情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding:15px;padding-bottom:0px;">
                <tableList :tableData='resourceVisits1.tableList' :headerData='resourceVisits1.headerList'></tableList>
                <div class="viewMore">
                  <el-button v-if="resourceVisits1.tableList.length >= 6" size="small" class="upAndDown" style="margin-left:0px;" @click="seeMore(resourceVisits1.url,'选课情况(前100名)',resourceVisits1.headerList)">查看更多</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第四层 -->
      <!-- <el-row :gutter="12" class="sameLayer">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一个月用户情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'oneMonthUsersChart'" :datas='oneMonthUsers.dataList' :transverseData='oneMonthUsers.transverseData' :colorList='oneMonthUsers.colorList' :legendList='oneMonthUsers.legendList' :gridWidth='true' :innerText="'单位：人'"></discountChart>
            </div>
          </div>
        </el-col>
      </el-row> -->

      <!-- 第五层 -->
      <!-- <el-row :gutter="12" class="sameLayer">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近三个月用户情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'threeMonthUsersChart'" :datas='threeMonthUsers.dataList' :transverseData='threeMonthUsers.transverseData' :colorList='threeMonthUsers.colorList' :legendList='threeMonthUsers.legendList' :gridWidth='true' :innerText="'单位：人'"></discountChart>
            </div>
          </div>
        </el-col>
      </el-row> -->

      <!-- 第六层 -->
      <!-- <el-row :gutter="12" class="sameLayer">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一个月资源新增情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'oneMonthResourcesChart'" :datas='oneMonthResources.dataList' :transverseData='oneMonthResources.transverseData' :colorList='oneMonthResources.colorList' :legendList='oneMonthResources.legendList' :gridWidth='true' :innerText="'单位：个'"></discountChart>
            </div>
          </div>
        </el-col>
      </el-row> -->

      <!-- 第七层 -->
      <!-- <el-row :gutter="12" class="sameLayer">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近三个月资源新增情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'threeMonthResourcesChart'" :datas='threeMonthResources.dataList' :transverseData='threeMonthResources.transverseData' :colorList='threeMonthResources.colorList' :legendList='threeMonthResources.legendList' :gridWidth='true' :innerText="'单位：个'"></discountChart>
            </div>
          </div>
        </el-col>
      </el-row> -->

      <!-- 第八层 -->
      <!-- <el-row :gutter="12" class="sameLayer">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一个月访问量新增情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'oneMonthVisitsChart'" :datas='oneMonthVisits.dataList' :transverseData='oneMonthVisits.transverseData' :colorList='oneMonthVisits.colorList' :legendList='oneMonthVisits.legendList' :gridWidth='true' :innerText="'单位：次'"></discountChart>
            </div>
          </div>
        </el-col>
      </el-row> -->

      <!-- 第九层 -->
      <!-- <el-row :gutter="12" class="sameLayer" style="margin-bottom:0px;">
        <el-col :span="24">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近三个月访问量新增情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'threeMonthVisitsChart'" :datas='threeMonthVisits.dataList' :transverseData='threeMonthVisits.transverseData' :colorList='threeMonthVisits.colorList' :legendList='threeMonthVisits.legendList' :gridWidth='true' :innerText="'单位：次'"></discountChart>
            </div>
          </div>
        </el-col>
      </el-row> -->
      <el-backtop :bottom="80" target=".page" class="backtops"></el-backtop>
    </div>

    <!-- 表格中查看更多 -->
    <el-dialog :title="detailsBox.title" :visible.sync="detailsBox.show" :close-on-click-modal="false" width="600px" class="pop_up distribute" append-to-body :before-close="handleClose">
      <div class="moreBox">
        <tableList :tableData='detailsBox.data.tableList' :headerData='detailsBox.data.headerList'></tableList>
      </div>
      <div class="tx-center">
        <el-button size="small" @click="handleClose">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 加载组件 -->
    <loading class="loading_box" v-if="this.$store.state.loading"></loading>
  </div>
</template>


<script>
import vcolumnarChart from '@/components/chart/vcolumnarChart.vue' //引入竖柱状图图表
import discountChart from '@/components/chart/discountChart.vue' //引入折线图图表
import tableList from '@/components/tableList.vue' //表格


export default {
  components: {
    vcolumnarChart,
    discountChart,
    tableList
  },
  data() {
    return {
      colorList: ['#1BF6F8', '#3B86FF', '#FA4798', '#6FE05F', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'],  //柱状图或折线图的颜色
      formResourceBase: {
        name: ''
      },
      regionList: [], //下拉子项目

      // 第一层
      userProgress: {  //用户建设进度
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      tsConstructionProgress: {  //建设单位用户建设情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      tsActivity: {  //建设单位师生活跃度占比
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },


      // 第二层
      material: {  //素材资源建设进度
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      // construction: {  //资源活跃数
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },
      activeResources: { // 资源活跃占比
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      materialResources: {   //素材资源建设质量
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },


      // 第三层
      originalResources: {  // 原创资源占比
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      constructionProgress: { // 课程建设进度
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      resourceVisits1: {    //选课情况
        tableList: [],
        headerList: [],
        url: ''
      },



      // // 第四层
      // oneMonthUsers: { //近一个月用户情况
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },



      // // 第五层
      // threeMonthUsers: { //近三个月用户情况
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },


      // // 第六层
      // oneMonthResources: { //近一个月资源新增情况
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },


      // // 第七层
      // threeMonthResources: { //近三个月资源新增情况
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },


      // // 第八层
      // oneMonthVisits: { //近一个月访问量新增情况
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },


      // // 第九层
      // threeMonthVisits: { //近三个月访问量新增情况
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },



      // 表格弹窗
      detailsBox: {
        title: '',
        show: false,
        data: {
          tableList: [],
          headerList: []
        }
      }
    }
  },
  created() {
    this.subproject()
    this.resourceVisits1.url = this.$apiurls.getCourseStudentSeletionCourseList
  },
  methods: {
    // 获取子项目数据
    subproject() {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionPlanList, {
        name: "",
        pageDto: {
          pageNum: 1,
          pageSize: 9999
        },
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.regionList = res.data.list
          this.formResourceBase.name = res.data.list[0]

          // 第一层
          this.userProgressDom(res.data.list[0])
          this.tsConstructionProgressDom(res.data.list[0])
          this.tsActivityDom(res.data.list[0])

          // 第二层
          this.materialDom(res.data.list[0])
          // this.constructionDom(res.data.list[0])
          this.activeResourcesDom(res.data.list[0])
          this.materialResourcesDom(res.data.list[0])

          // 第三层
          this.originalResourcesDom(res.data.list[0])
          this.constructionProgressDom(res.data.list[0])
          this.resourceVisits1Dom(res.data.list[0])

          // //第四层
          // this.oneMonthUsersDom(res.data.list[0])

          // //第五层
          // this.threeMonthUsersDom(res.data.list[0])

          // //第六层
          // this.oneMonthResourcesDom(res.data.list[0])

          // //第七层
          // this.threeMonthResourcesDom(res.data.list[0])

          // //第八层
          // this.oneMonthVisitsDom(res.data.list[0])

          // //第九层
          // this.threeMonthVisitsDom(res.data.list[0])
        }
      });
    },
    // 切换项目
    switchItems() {
      // 第一层
      this.userProgressDom()
      this.tsConstructionProgressDom()
      this.tsActivityDom()


      // 第二层
      this.materialDom()
      // this.constructionDom()
      this.activeResourcesDom()
      this.materialResourcesDom()

      // 第三层
      this.originalResourcesDom()
      this.constructionProgressDom()
      this.resourceVisits1Dom()


      // //第四层
      // this.oneMonthUsersDom()

      // //第五层
      // this.threeMonthUsersDom()

      // //第六层
      // this.oneMonthResourcesDom()

      // //第七层
      // this.threeMonthResourcesDom()

      // //第八层
      // this.oneMonthVisitsDom()

      // //第九层
      // this.threeMonthVisitsDom()
    },
    // 第一层
    // 用户建设进度
    userProgressDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 6,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.userProgress.dataList = [realValue, targetValue]
          this.userProgress.transverseData = nameList
          this.userProgress.colorList = this.colorList
          this.userProgress.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // 建设单位用户建设情况
    tsConstructionProgressDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 7,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.tsConstructionProgress.dataList = [realValue, targetValue]
          this.tsConstructionProgress.transverseData = nameList
          this.tsConstructionProgress.colorList = this.colorList
          this.tsConstructionProgress.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // 建设单位师生活跃度占比
    tsActivityDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 8,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.tsActivity.dataList = [realValue, targetValue]
          this.tsActivity.transverseData = nameList
          this.tsActivity.colorList = this.colorList
          this.tsActivity.legendList = ['监测平台值', '任务目标值']
        }
      });
    },


    // 第二层
    // 素材资源建设进度
    materialDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 9,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.material.dataList = [realValue, targetValue]
          this.material.transverseData = nameList
          this.material.colorList = this.colorList
          this.material.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // // 资源活跃数
    // constructionDom(name) {
    //   this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
    //     echartsType: 10,
    //     name: this.formResourceBase.name ? this.formResourceBase.name : name,
    //     type: 2
    //   }, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       var realValue = []
    //       var targetValue = []
    //       var nameList = []
    //       for (let i = 0; i < res.data.length; i++) {
    //         if (!res.data[i].value) {
    //           res.data[i].value = {}
    //           res.data[i].value.realValue = 0
    //           res.data[i].value.targetValue = 0
    //         } else {
    //           if (!res.data[i].value.realValue) {
    //             res.data[i].value.realValue = 0
    //           }
    //           if (!res.data[i].value.targetValue) {
    //             res.data[i].value.targetValue = 0
    //           }
    //         }
    //         realValue.push(res.data[i].value.realValue)
    //         targetValue.push(res.data[i].value.targetValue)
    //         nameList.push(res.data[i].name)
    //       }
    //       this.construction.dataList = [realValue, targetValue]
    //       this.construction.transverseData = nameList
    //       this.construction.colorList = this.colorList
    //       this.construction.legendList = ['监测平台值', '任务目标值']
    //     }
    //   });
    // },
    // 资源活跃占比
    activeResourcesDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 12,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.activeResources.dataList = [realValue, targetValue]
          this.activeResources.transverseData = nameList
          this.activeResources.colorList = this.colorList
          this.activeResources.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // 素材资源建设质量
    materialResourcesDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 10,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.materialResources.dataList = [realValue, targetValue]
          this.materialResources.transverseData = nameList
          this.materialResources.colorList = this.colorList
          this.materialResources.legendList = ['监测平台值', '任务目标值']
        }
      });
    },


    // 第三层
    // 原创资源占比
    originalResourcesDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 11,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.originalResources.dataList = [realValue, targetValue]
          this.originalResources.transverseData = nameList
          this.originalResources.colorList = this.colorList
          this.originalResources.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // 课程建设进度
    constructionProgressDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 13,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.constructionProgress.dataList = [realValue, targetValue]
          this.constructionProgress.transverseData = nameList
          this.constructionProgress.colorList = this.colorList
          this.constructionProgress.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // 选课情况
    resourceVisits1Dom(name) {
      this.$axios.post(this.$apiurls.getCourseStudentSeletionCourseList, {
        limitNum: '7',
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data.length >= 7) {
            res.data.splice(res.data.length - 1, 1)
          }
          this.resourceVisits1.tableList = res.data
          this.resourceVisits1.headerList = [{
            name: '序号',
            prop: 'index'
          }, {
            name: '课程名称',
            prop: 'name'
          }, {
            name: '院校名称',
            prop: 'school'
          }, {
            name: '选课人数',
            prop: 'num'
          }]
        }
      });
    },




    // // 第四层
    // // 近一个月用户情况
    // oneMonthUsersDom() {
    //   this.oneMonthUsers.dataList = [50, 80, 90, 450, 80, 90]
    //   this.oneMonthUsers.transverseData = [2019, 2020, 2021, 2022, 2023, 2024]
    //   this.oneMonthUsers.colorList = this.colorList
    //   this.oneMonthUsers.legendList = ['数据1']
    // },

    // //第五层
    // // 近三个月用户情况
    // threeMonthUsersDom() {
    //   this.threeMonthUsers.dataList = [50, 80, 90, 450, 80, 90]
    //   this.threeMonthUsers.transverseData = [2019, 2020, 2021, 2022, 2023, 2024]
    //   this.threeMonthUsers.colorList = this.colorList
    //   this.threeMonthUsers.legendList = ['数据1']
    // },

    // //第六层
    // //  近一个月资源新增情况
    // oneMonthResourcesDom() {
    //   this.oneMonthResources.dataList = [50, 80, 90, 450, 80, 90]
    //   this.oneMonthResources.transverseData = [2019, 2020, 2021, 2022, 2023, 2024]
    //   this.oneMonthResources.colorList = this.colorList
    //   this.oneMonthResources.legendList = ['数据1']
    // },

    // //第七层
    // //  近三个月资源新增情况
    // threeMonthResourcesDom() {
    //   this.threeMonthResources.dataList = [50, 80, 90, 450, 80, 90]
    //   this.threeMonthResources.transverseData = [2019, 2020, 2021, 2022, 2023, 2024]
    //   this.threeMonthResources.colorList = this.colorList
    //   this.threeMonthResources.legendList = ['数据1']
    // },

    // //第八层
    // //  近一个月访问量新增情况
    // oneMonthVisitsDom() {
    //   this.oneMonthVisits.dataList = [50, 80, 90, 450, 80, 90]
    //   this.oneMonthVisits.transverseData = [2019, 2020, 2021, 2022, 2023, 2024]
    //   this.oneMonthVisits.colorList = this.colorList
    //   this.oneMonthVisits.legendList = ['数据1']
    // },

    // //第九层
    // //  近三个月访问量新增情况
    // threeMonthVisitsDom() {
    //   this.threeMonthVisits.dataList = [50, 80, 90, 450, 80, 90]
    //   this.threeMonthVisits.transverseData = [2019, 2020, 2021, 2022, 2023, 2024]
    //   this.threeMonthVisits.colorList = this.colorList
    //   this.threeMonthVisits.legendList = ['数据1']
    // },


    // 查看更多
    seeMore(url, title, headerList) {
      this.$store.commit('isLoading', true);
      this.detailsBox.data.tableList = []
      this.$axios.post(url, {
        limitNum: "100",
        name: this.formResourceBase.name
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.$message({
            message: '查询成功！',
            type: 'success'
          });
          this.detailsBox.data.tableList = res.data
          this.detailsBox.data.headerList = headerList
          this.detailsBox.show = true
          this.detailsBox.title = title
          this.$store.commit('modifyVague', true);
          this.$store.commit('isLoading', false);
        }
      }).catch(_ => {
        this.$store.commit('isLoading', false);
      });
    },
    // 关闭弹窗
    handleClose() {
      this.detailsBox.show = false
      this.$store.commit('modifyVague', false);
      this.$store.commit('isLoading', false);
    },
  }
}
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/table.scss" scoped></style>
<style  lang="scss" scoped>
// 图表
.sameLayer {
  position: relative;
  margin-bottom: 12px;
}

.sameLayer .el-col {
  height: 400px;
}

.sameLayer .echartsHeight {
  width: 100%;
  height: calc(100% - 40px);
}

// 带legend
.beltLegend .el-col {
  height: 420px;
}

.el-row:last-child {
  margin-bottom: 0px;
}

.moreBox {
  height: 550px;
  overflow-y: auto;
}
.tx-center {
  margin-top: 10px;
}
</style>